import Sales from "../../../services/sales";
import Auth from "../../../services/auth";
import Contracts from "../../../services/contracts";
import Vehicles from "../../../services/vehicles";
import C from "../../common/constantes";
import GenericSummary from "../../common/generic-summary.vue";
import successPage from "../../common/adhesion/success.vue";
import errorPage from "../../common/adhesion/error.vue";
import messageDialog from "../../../components/message-dialog.vue";
import * as Utils from "../../../utils";

export default {
  data() {
    return {
      msgError: undefined,
      loading: undefined,
      contract: undefined,
      replaceTax: undefined,
      plate: undefined,
      vehicles: [],
      salesOrder: undefined,
      address: Auth.currentUser.address,
      whereToDelivery: "0",
      shipmentType: undefined,
      salesResponse: undefined,
      code: undefined,
      planId: undefined,
      planName: undefined,
      isMobile: false,
      tagSerialNumber: "",
      activationSuccess: false,
      activationError: null,
      tagInHandActivated: false,
    };
  },

  computed: {
    addressInit() {
      return Auth.currentUser.address;
    },
    contractId() {
      return this.$route.params.contractId;
    },
    user() {
      return Auth.currentUser;
    },
    tagActivationSuccessMessage() {
      return C.MSG_01_REPLACE_IN_HAND_SUCCESS;
    },
  },

  mounted() {
    this._resizeReplaceTag = () => {
      this.isMobile = window.innerWidth <= 769;
    };
    this._resizeReplaceTag();
    window.addEventListener("resize", this._resizeReplaceTag);

    this.loading = Contracts.getContractByContractId(this.contractId).then(
      (r) => {
        this.contract = r;
        this.planId = r.plan.planId;
        this.getPlanInfo();
      },
    );
    Vehicles.getVehicleById(this.$route.params.vehicleId).then((r) => {
      this.vehicles = [r];
      this.plate = r.plate;
    });
  },

  beforeDestroy() {
    if (this._resizeReplaceTag) {
      window.removeEventListener("resize", this._resizeReplaceTag);
    }
  },

  methods: {
    startRequest() {
      this.$refs.GenericSummary.getInfos().then((r) => {
        if (!r || !r.address) {
          return;
        }
        this.address = r.address;
        this.whereToDelivery = r.whereToDelivery;
        this.shipmentType = r.shipmentType;
        this.tagSerialNumber = r.tagSerialNumber;
        this.doRequest();
      });
    },
    onTagActivationState(activated) {
      this.tagInHandActivated = activated === true;
      if (activated) {
        this.activationSuccess = true;
        this.activationError = null;
      }
    },

    cancelar() {
      messageDialog
        .show({
          title: "Cancelar Substituição",
          message: "Deseja cancelar o pedido de substituição?",
          type: "OK-CANCEL",
        })
        .then((res) => {
          if (res == "OK") {
            this.$router.push({
              name: "plans",
            });
          }
        });
    },

    getPlanInfo() {
      this.loading = Sales.getPlanById(this.planId).then((resp) => {
        if (
          this.planId == C.PLAN_POS ||
          this.planId == C.PLAN_PRE_SEM_TAXA ||
          this.contract.replaceTax
        ) {
          this.replaceTax = this.contract.replaceTax || 0;
        } else {
          this.replaceTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {
            return o.taxId == C.REPLACE_TAXID;
          })[0].value;
        }

        this.planName = resp.name;

        this.salesOrder = {
          _interface: "WEBSITE",
          planId: this.planId,
          status: null,
          type: "SUBSTITUIÇÃO DE TAG",
          salesType: "REPLACETAG",
          taxpayerIdSeller: null,
          price: this.replaceTax,
          logisticsDistribution: null,
          vehicleId: null,
          contract: this.contractId,
          shipment: null,
          vehicles: this.vehicles,
          products: [
            {
              productId: 6,
              productName: "SUBSTITUIÇÃO DE TAG",
              valueUnit: this.replaceTax,
              quantity: this.vehicles.length,
              valueTotal: this.replaceTax,
            },
          ],
        };
      });
    },

    doRequest() {
      // TAG em mãos: substituição e ativação já feitas no generic-summary (validateTagInHand).
      if (this.shipmentType == 4) {
        this.activationSuccess = true;
        this.activationError = null;
        return;
      }

      const req = {
        moveMaisId: this.user.moveMaisId,
        contractId: this.contractId,
        deliveryAddressId: this.address.addressId,
        value: this.replaceTax,
        secureCode: this.user.taxIdNumber.substring(0, 4),
        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        vehicles: this.vehicles,
        shipmentType: this.shipmentType,
      };

      if (this.shipmentType == 4 && this.tagSerialNumber) {
        this.vehicles[0].tagSerialNumber = this.tagSerialNumber;
      } else {
        this.vehicles[0].tagSerialNumber = this.vehicles[0].serialNumber;
      }
      this.vehicles[0].tag = null;
      this.vehicles[0].installDate = new Date(this.vehicles[0].installDate);

      let url_atual = window.location.href;

      if (url_atual != "") {
        var regexp = new RegExp(/\S+pdv\S+/i);
        var n = regexp.test(url_atual);
        if (n) {
          req["promotionCode"] = "GRAALKM29";
          req["logisticsDistribution"] = "FOB";
        }
      }

      if (Utils.isCaminhoParana(this.planId)) {
        req["promotionCode"] = "CAMINHOSDOPARANA";
        req["logisticsDistribution"] = "FOB";
      }

      if (this.whereToDelivery != "0") {
        req["promotionCode"] = this.whereToDelivery;
        req["logisticsDistribution"] = "FOB";
      }

      if (req.shipmentType == 3) {
        req.logisticsDistribution = "FOB";
      }

      let p = Sales.requestTagReplacement(req).catch((err) => {
        const data = err && err.data ? err.data : {};
        this.msgError =
          (data.status && data.status.message) ||
          data.message ||
          "Não foi possível concluir a substituição de TAG.";
        this.code = data.status && data.status.code;
        this.salesResponse = undefined;
        $("body").stop().animate(
          {
            scrollTop: 0,
          },
          "500",
          "swing",
        );
        return messageDialog.show({
          headerClass: "modal-danger",
          title: "Erro!",
          message: this.msgError,
          type: "OK",
        });
      });

      this.$store.dispatch("loading", p);
    },
    finalizar() {
      this.$router.push("/conta/meus-planos");
    },
  },

  components: {
    successPage,
    errorPage,
    GenericSummary,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/replace-tag/replace-tag.js